import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AwaitModules, ComponentSync, LL_V_L } from '@nu-art/thunderstorm-frontend/index';
import { Outlet } from 'react-router';
import { QuaiAdvisorPageLoader } from '../V4/index.js';
import { ModuleFE_AdvisorSession } from '../../_entity/advisor-session/index.js';
import { ModuleFE_EMInterface } from '../../_entity/runtime/em-interface/index.js';
import { modulesToAwait_AdvisorConfig } from '../../modules/index.js';
export class ComponentValidateSession extends ComponentSync {
    deriveStateFromProps(nextProps, state) {
        state.syncingArtifact ??= true;
        state.loadingInitialData ??= false;
        return state;
    }
    __onLoadingInitialData() {
        // @ts-ignore
        this.state.loadingInitialData = ModuleFE_EMInterface.isLoadingInitialData();
        this.forceUpdate();
    }
    async componentDidMount() {
        if (!ModuleFE_AdvisorSession.hasSessionData())
            return;
        try {
            ModuleFE_EMInterface.startFirebaseListeners();
            await ModuleFE_EMInterface.syncSnapShot();
            this.setState({ syncingArtifact: false });
        }
        catch (err) {
            this.logError('error', err);
            this.setState({ error: err });
        }
    }
    render() {
        if (!ModuleFE_AdvisorSession.hasSessionData())
            return _jsx("div", { className: 'no-session-message', children: "No Session ID found. Make sure you launch the Advisor using Smart on FHIR..." });
        if (this.state.error) {
            return _jsxs(LL_V_L, { className: 'ts-error-boundary__error', children: [_jsx("div", { className: 'ts-error-boundary__error-title', children: "Error Message" }), _jsx("div", { className: 'ts-error-boundary__error-message', children: this.state.error.toString() })] });
        }
        return _jsx(AwaitModules, { modules: modulesToAwait_AdvisorConfig, customLoader: _jsx(QuaiAdvisorPageLoader, { text: 'Loading Configuration...' }), children: _jsx(Outlet, {}) });
    }
}
//# sourceMappingURL=ComponentValidateSession.js.map